export function useStickyObserver (elementId: string) {
  const isHidden = ref(false)

  onMounted(() => {
    const observer = new MutationObserver(() => {
      const anchor = document.getElementById(elementId);

      if (anchor) {
        const intersectionObserver = new IntersectionObserver((entries) => {
          isHidden.value = entries[0].isIntersecting
        }, { threshold: 0.1 })

        intersectionObserver.observe(anchor)
        observer.disconnect()
      }
    })

    observer.observe(document.body, { childList: true, subtree: true })
  })

  return { isHidden }
}
